import {
  Component,
  Input,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import navData from '../../../../../public/i18n-assets/en/home.json';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { TranslationService, I18nModule } from '@spartacus/core';
import { NgIf, NgFor, NgClass } from '@angular/common';


@Component({
    selector: 'app-custom-landing-menu-card',
    templateUrl: './custom-home-menus.component.html',
    styleUrls: ['./custom-home-menus.component.scss'],
    imports: [NgIf, NgFor, RouterLink, NgClass, I18nModule]
})
export class CustomHomeMenusComponent implements OnInit {
  units: any = [];
  menus: any;
  filteredMenus: any = [];
  portsideMenus: any = [];
  bondedwarehouseMenus: any = [];
  adminMenus: any = [];
  listSrc = '/images/list-view.svg';
  gridSrc = '/images/grid-view-orange.svg';
  grid = true;
  list = false;
  email :string;
  enableLoader:boolean=false;
  bidsOffersName:string;
  displayMenu=[];
  constructor(
    private customProfileService: CustomProfileService,
    private router: Router,
    private userService:UserAccountFacade,
     private translation: TranslationService,
  ) {}

  ngOnInit(): void {
    this.userService.get().subscribe((res:any)=>{
      console.log(res);
      if(res){
        this.email=res.email;
        this.fetchBhpUnitMenus(res.email);
      }

    })

    this.customProfileService.changeGroupCompany.subscribe(data=>{
      if(data=='clicked'){
        this.fetchBhpUnitMenus(this.email);
      }
    })

  }


  fetchBhpUnitMenus(email:string) {
    if (this.router.url === '/') {
      document.querySelector('header').style.backgroundImage =
        'None';
    }
    this.enableLoader = true;
    this.customProfileService.getBhpData(email).subscribe(
      (response) => {
        if (response) {
          this.enableLoader =false;
          this.filteredMenus = [];
          this.portsideMenus=[];
          this.bondedwarehouseMenus=[];
          this.adminMenus=[];
          this.units = response.myB2BUnits;
          let localGrp = localStorage.getItem('groupCompany');
          let tobeused
          if(localGrp ==null || localGrp ==undefined || localGrp ==''){
            tobeused = this.units[0]?.uid;
          }else{
            tobeused = localGrp;
          }
           this.bidsOffersName=this.units.filter((data)=>{
            return data.uid === tobeused;
                   })[0]?.bidsOffersName;
          this.menus = this.units.filter((data) => {
            return data.uid === tobeused;
          })[0]?.menuDisplay;
          console.log('menus:', this.menus);
          Object.keys(this.menus).forEach((key) => {
            let titlekey=key;
            if (this.menus[key] === 'show'&& key!=='shipsAndDocsRail'&&key!=='shipsAndDocsCons') {
              if( key==='bidsAndOffers' && this.bidsOffersName){
              titlekey='Orders'
            }
              this.filteredMenus.push({
                menuTitle: titlekey,
                isShow: this.menus[key],
                ...navData.home.navigationMenus[key],
              });
            }
          });


          this.displayMenu=this.getTrueKeys(this.menus);
          if(this.displayMenu.includes('shipment')){
              this.portsideMenus.push({
                title: 'shipment',
                type:'arrivals',
                route: navData.home.navigationMenus['shipment'].subItems.portside.items.arrivals.route,
                menuIcon: navData.home.navigationMenus['shipment'].subItems.portside.items.arrivals.menuIcon
              });
              this.bondedwarehouseMenus.push({
                title: 'shipment',
                type:'arrivals',
                route: navData.home.navigationMenus['shipment'].subItems.bondedwarehouse.items.arrivals.route,
                menuIcon: navData.home.navigationMenus['shipment'].subItems.bondedwarehouse.items.arrivals.menuIcon
              });
          }
          if(this.displayMenu.includes('inspection')){
            this.portsideMenus.push({
                title: 'shipment',
                type:'inspection',
                route: navData.home.navigationMenus['shipment'].subItems.portside.items.inspection.route,
                menuIcon: navData.home.navigationMenus['shipment'].subItems.portside.items.inspection.menuIcon
              });
              this.bondedwarehouseMenus.push({
                title: 'shipment',
                type:'inspection',
                route: navData.home.navigationMenus['shipment'].subItems.bondedwarehouse.items.inspection.route,
                menuIcon: navData.home.navigationMenus['shipment'].subItems.bondedwarehouse.items.inspection.menuIcon
              });
          } if(this.displayMenu.includes('screening') ){
            this.portsideMenus.push({
                title: 'batches',
                type:'screening',
                route: navData.home.navigationMenus['batches'].subItems.portside.items.screening.route,
                menuIcon: navData.home.navigationMenus['batches'].subItems.portside.items.screening.menuIcon
              });
              this.bondedwarehouseMenus.push({
                title: 'batches',
                type:'screening',
                route: navData.home.navigationMenus['batches'].subItems.bondedwarehouse.items.screening.route,
                menuIcon: navData.home.navigationMenus['batches'].subItems.bondedwarehouse.items.screening.menuIcon
              });
          }
          if(this.displayMenu.includes('quality') || this.displayMenu.includes('batches')){ // this.displayMenu.includes('batches') is added to display quality tile till we get the quality menu in the api response. This is hard coded until we get response
              this.portsideMenus.push({
                title: 'batches',
                type:'qualityInspection',
                route: navData.home.navigationMenus['batches'].subItems.portside.items.qualityInspection.route,
                menuIcon: navData.home.navigationMenus['batches'].subItems.portside.items.qualityInspection.menuIcon
              });
          } if(this.displayMenu.includes('batches') ){
             this.portsideMenus.push({
                title: 'batches',
                type:'delivery',
                route: navData.home.navigationMenus['batches'].subItems.portside.items.delivery.route,
                menuIcon: navData.home.navigationMenus['batches'].menuIcon
              });
          } 
           if(this.displayMenu.includes('materials') ){
            this.adminMenus.push( navData.home.navigationMenus['materials']);
          }
          if(this.displayMenu.includes('invitationToBid') ){
            this.adminMenus.push( navData.home.navigationMenus['invitationToBid']);
          }
          if(this.displayMenu.includes('bidsAndOffers') ){
            this.adminMenus.push( navData.home.navigationMenus['bidsAndOffers']);
          }
           if(this.displayMenu.includes('shipsAndDocs') ){
            this.adminMenus.push( navData.home.navigationMenus['shipsAndDocs']);
          }
            if(this.displayMenu.includes('myCompany') ){
            this.adminMenus.push( navData.home.navigationMenus['myCompany']);
          }
          if(this.displayMenu.includes('bhpTeam') ){
            this.adminMenus.push( navData.home.navigationMenus['bhpTeam']);
          }
          if(this.displayMenu.includes('consignment') ){
            this.adminMenus.push( navData.home.navigationMenus['consignment']);
          }
          if(this.displayMenu.includes('bilateral') ){
            this.adminMenus.push( navData.home.navigationMenus['bilateral']);
          } 
          if(this.displayMenu.includes('Orders') ){
            this.adminMenus.push( navData.home.navigationMenus['Orders']);
          }
          if(this.displayMenu.includes('ctContracts') ){
            this.adminMenus.push( navData.home.navigationMenus['ctContracts']);
          }
          console.log('portsideMenus:', this.portsideMenus);
          console.log('bondedwarehouseMenus:', this.bondedwarehouseMenus);
          console.log('adminMenus:', this.adminMenus);
        }
      },
      (err) => {
        this.enableLoader =false;
        console.log('fetchBhpUnitMenus exception:', err);
      }
    );
  }
  menuTranslation(r1?: any, r2?: any, r3?: any): string {
    return `${r1}.${r2}.${r3}`;
  }
  viewGrid() {
    this.gridSrc = '/images/grid-view-orange.svg';
    this.listSrc = '/images/list-view.svg';
    this.grid = true;
    this.list = false;
  }
  viewList(): any {
    this.listSrc = '/images/list-view-orange.svg';
    this.gridSrc = '/images/grid-view.svg';
    this.list = true;
    this.grid = false;
  }
  navigate(route){
    this.router.navigate([route])

  }
   getTrueKeys(obj) {
    return Object.keys(obj).filter(key => obj[key] === 'show' && key!=='shipsAndDocsRail'&&key!=='shipsAndDocsCons');
  }

  changeTransalation(t,u){
    console.log('translation key:', 'home.navigationMenus.' + t + '.' + u);
    this.translation
        .translate('home.navigationMenus.' + t + '.' + u)
        .subscribe((res) => {
          console.log('translation result:', res);
            return res
        });
  }
}
